export default {
  home: 'Anmeldung',
  status: 'Überprüfung',
  quiz: 'Fragen',
  clues: 'Hinweise',
};
